import CenterLayout from "../layouts/CenterLayout";
import Box from "../components/box";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { API_URL } from "../config/constant";
import axios from "axios";
import { CircleLoader } from "react-spinners";
import { useCopyToClipboard } from "react-use";

function MainPage() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [{}, copyToClipboard] = useCopyToClipboard();

  useEffect(() => {
    // Ejecucion inicial.
    loadData();

    // Cada diez segundos ejecuta ese codigo.
    const interval = setInterval(loadData, 10000);

    // Limpiar
    return () => clearInterval(interval);
  }, []);

  const loadData = () => {
    setLoading(true);
    axios
      .get(API_URL + "/motto", { mode: "cors" })
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((error) => {
        throw error;
      });
  };
  return (
    <CenterLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Writember</title>
      </Helmet>
      {loading && <CircleLoader color="white" />}
      {loading === false && data && (
        <Box
          text={data.content}
          copyToClipboard={copyToClipboard}
          author={data.author}
        />
      )}
    </CenterLayout>
  );
}

export default MainPage;
